import React, { Component } from 'react';
import   SideNav from "./../../component/sidenav/sidenav.js"
import "./activity.css"
import  AuthService  from "../api/authentication.js";
import localforage from 'localforage';
import  Moble from "./../../component/sidenav/moble.js"
import  Transaction from "./transactions"
import TimeAgo from 'react-timeago'
import date from 'date-and-time';
import Moment from 'react-moment'
// import  AuthService  from "../api/authentication.js";




import {
    Link,
    Redirect
  } from 'react-router-dom'


  const Auth = new AuthService();
  // https://uvune-events.herokuapp.com
class Activity extends Component {

    constructor(props){
        super(props)
        this.state = {
            loading : false,
            errorend  : false,
            transactions : [],
            submitIftrue : false,
            noerorrpage :  true,
            clickShow : false,
            data : [],
            paymentItem : [],
            domain: "https://uvune-events.herokuapp.com",  
            isActive : false 
            // isFirst : false
        }

     
    }

    componentDidMount(){
        
        this.props.noerorrpage(this.state.noerorrpage)
        this.setState({
            isActive:true
        })
        const requestOptions = {
            method: 'GET', 
            headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
        };
        fetch(this.state.domain+"/users/"+ Auth.getProfile().userId, requestOptions)
        .then(res => res.json())
        .then((result)=>{
            if(result){
                fetch(this.state.domain+"/transactions?organizers_id="+result.organizers_id, requestOptions)
                .then(res => res.json())
                .then((result)=>{
                    if(result){
                        if(result.code === 500){
                                this.props.history.replace('/info');
                             }else{
                            // console.log("data transations ====", result)
                            this.setState({
                                loading :false,
                                transactions: result.data
                            })       
                         }  
                      
                    }else{
                        this.setState({
                            loading :true
                        }) 
                      }
                    }).catch( (error) => {
                        //  console.log("errro", error);
                        //  console.log("error load", error )
                     });   
            }else{
                this.setState({
                    loadingTuition :true
                }) 
            }
        })

        

      }
      clickIfShow=(data)=>{
        this.setState({
            data : data ,
            clickShow : true,
            loading :true
        })
        const requestOptions = {
            method: 'GET', 
            headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
          };
    
        // console.log("transt data", data.checkoutData.payment_item_id)
        fetch(this.state.domain+"/payment-item/"+data.checkoutData.payment_item_id, requestOptions)
                .then(res => res.json())
                .then((result)=>{
                    if(result){
                            // console.log("data transations ====", result)
                            this.setState({
                               paymentItem :result,
                               loading :false
                            })
                            
                    }else{
                        this.setState({
                            loading :true
                        }) 
                      }
                    }).catch( (error) => {
                });   

      }

      closeShow = ( )=>{
        this.setState({
            clickShow : false
        })
      }
    
        
           
          
    logout = () =>{
        // console.log("judge love")
        this.props.logout()
      }
  render() {
    // console.log("kdjgjgkfnibfs g======" ,this.props.getIsfirst, this.props.organizer._id)
    return (
        

        !this.props.isAuthenticated ? (
            <div className="hero is-bold is-fullheight">
            <div className="level-item">
              <a className="button is-loading is-large is-light">Loading</a>
            </div>
            <div className="level-item">
              <span>Trying to login...</span>
            </div>
          </div>
            ) : 
            <div className="Activity"> 
              <div className="Activity-moble-nav-body">
                < Moble  logout={this.logout} isActive={this.state.isActive}/>
              </div>  
              <SideNav vanImage={this.props.organizer.image_url} email={this.props.user.email} 
                      logout={this.logout} name={this.props.user.first_name + " " + this.props.user.last_name}
                      organizers404={this.props.organizers404} isActive={this.state.isActive}
                      /> 
            
                 <div className="main">
                
                     <div className="search-activity-body-full">
                       <div className="field">
                            <p className="control has-icons-left has-icons-right">
                                <input  className="input is-rounded"  type="Search" placeholder="Search" />
                                <span className="icon is-small is-left">
                                 <i className="fas fa-search"></i>
                                </span>
                               
                            </p>
                         </div>
                      </div>    
                     <div className="header-activity-body">
                         <h5 className="title is-5"> Activity</h5>
                     </div>


                     <div className="Activity-table-responsive-body">
                        {
                            this.state.clickShow ?
                             <div> 
                                 {
                                     !this.state.loading ? 
                                     <div className="columns">
                                     <div className="column is-half">
                                        <p className="activity-show-data-para">CHECKOUT DATA</p> 
                                        <hr/>
                                       
                                       <div className="activity-show-data-checkout-body-left">
                                            <div className="activity-show-data-checkout-body-left-data">
                                                <p> Date	:	 <Moment  format="YYYY/MM/DD" date={this.state.data.createdAt} /> </p>
                                                </div>
                                            <table className="table is-bordered tutile-table-actitybody">
                                            
                                                    <tbody>
                                                            <tr>
                                                                <td>
                                                                <small className="tag">Fullname</small>
                                                                </td>
                                                                <td>
                                                                <small className="tag activity-tag-font">{this.state.data.checkoutData.fullname}</small>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                <small className="tag"> Email</small>
                                                                </td>
                                                                <td>
                                                                <small className="tag activity-tag-font">	{this.state.data.checkoutData.email}</small>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                <small className="tag">Phone</small>
                                                                </td>
                                                                <td>
                                                                <small className="tag activity-tag-font">	{this.state.data.checkoutData.phone}</small>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                <small className="tag"> State</small>
                                                                </td>
                                                                <td>
                                                                <small className="tag activity-tag-font">	{this.state.data.checkoutData.region}</small>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                <small className="tag">  Address</small>
                                                                </td>
                                                                <td>
                                                                <small className="tag activity-tag-font">	{this.state.data.checkoutData.address}</small>
                                                                </td>
                                                            </tr>
                                                                

                                                    </tbody>
                                                </table>
                                                {/* <div className="activity-show-data-checkout-body-left-data">
                                                <p> Amount	:	₦{this.state.data.checkoutData.amount} </p>
                                                </div> */}
                                                
                                            
                                            
                                            </div>
                                     </div>
                                 
                                     <div className="column">
                                         <p className="activity-show-data-para">SELECTED PAYMENT</p> 
                                         <hr style={{"width" :"90%"}}/>
                                         <div className="activity-show-data-checkout-body">
                                             <div className="table-container ">
                                                     <br/>
                                                 <table className="table is-bordered tutile-table-actitybody">
                                                     <tbody>
                                                        <tr>
                                                              <td>
                                                                 <small className="tag">Status</small>
                                                                 </td>
                                                                 <td>
                                                                 <small className="tag  activity-tag-font">{this.state.data.chargeStatus}</small>
                                                                 </td>
                                                             </tr>
                                                             <tr>
                                                                 <td>
                                                                 <small className="tag">Number of form</small>
                                                                 </td>
                                                                 <td>
                                                                 <small className="tag  activity-tag-font">{this.state.data.checkoutData.no_of_item}</small>
                                                                 </td>
                                                             </tr>
                                                             {/* <tr>
                                                                 <td>
                                                                 <small className="tag">Transaction number</small>
                                                                 </td>
                                                                 <td>
                                                                 <small className="tag  activity-tag-font">{this.state.data.checkoutData.chargeRef}</small>
                                                                 </td>
                                                             </tr> */}
                                                             <tr>
                                                                 <td>
                                                                 <small className="tag">
                                                                   {
                                                                       this.state.paymentItem.type === "FM" ?
                                                                       <p><i className="fab fa-wpforms"></i>  Form  name</p>
                                                                       :
                                                                       <p><i className="fas fa-tags">  </i>  Ticket   name </p> 
                                                                   }
                                                                 </small>
                                                                 </td>
                                                                 {/* <td>
                                                                   <Link  className="activity-link-tobig" to={`/build/${ this.state.paymentItem._id}`}>
                                                                     {this.state.paymentItem.name }
                                                                   </Link>
                                                                 </td> */}
                                                             </tr>
                                                       </tbody>
                                                  </table>
                                             </div>                                               
                                         </div>
                                     </div>
                                 </div>
                                   :
                                   <p>
                                       <a className="button is-loading">Loading</a>
                                   </p>
                                 }
                                  {
                                    !this.state.loading ?
                                      <div>
                                        <button onClick={this.closeShow} className="button is-primary is-focused">Back</button>
                                      </div>
                                    :
                                     <p></p>
                                  }
                                    
                                
                             </div>   
                            :
                            <div>
                             {
                                this.state.transactions ? 
                                <div> 
                                        {
                                            this.state.transactions === undefined || this.state.transactions === 0 ?
                                                <p></p>
                                                :
                                                <ul className="responsive-table">
                                                            <li className="table-header">
                                                                <div className="col col-1"><b>Name</b></div>
                                                                <div className="col col-2"><b>Eamil</b></div>
                                                                <div className="col col-3"><b>Amount</b>  </div>
                                                                {/* <div className="col col-4">Status</div> */}
                                                                <div className="col col-4"><b>Date</b></div>
                                                        </li>
                                                        {
                                                            this.state.transactions.map(trans=>{
                                                            return(
                                                                <Transaction
                                                                                 key={trans._id}
                                                                                
                                                                                data={trans}
                                                                                
                                                                                clickIfShow1={this.clickIfShow}
                                                                               
                                                                              
                                                                                /> 
                                                              
                                                                )
                                                            })
                                                        } 
                                                    </ul>

                                            }

                                       </div>
                                    :
                                    <div> 

                                    </div> 
                                }
                            </div>      
                        }
                           
                            
                     </div>
                </div>
           </div>     

    )

}





}

export default Activity;


// WEBPACK FOOTER //
// ./src/component/activity/activity.js